const electricity = (baseUrl: string): string => `${baseUrl}/ecommerce/v2/vas/electricity`;

export const recent = (baseUrl: string): string => `${electricity(baseUrl)}/recent`;
export const validate = (baseUrl: string): string => `${electricity(baseUrl)}/validate`;
export const placeOrder = (baseUrl: string): string => `${electricity(baseUrl)}/place-order`;
